/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {
  Switch,
  Route,
  useHistory,
  useLocation,
  useParams
} from 'react-router-dom'
import Amplify, { Auth } from 'aws-amplify';
import { CssBaseline, Typography } from '@material-ui/core';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import useSessionstorage from '@rooks/use-sessionstorage';
// Graco dependencies
import authConfig from './auth-config.js';
import GAuth from './GAuth/GAuth.jsx'
import Header from './Header/Header.jsx';
import HelpPage from './HelpPage/HelpPage.jsx';
import OrgCreate from './OrgPage/OrgCreate/OrgCreate.jsx';
import OrgPage from './OrgPage/OrgPage.jsx';
import OrgDetails from './OrgPage/OrgDetails/OrgDetails.jsx';
import ProfilePage from './ProfilePage/ProfilePage.jsx';
import DemoInvite from './DemoInvite/DemoInvite.jsx';
import Theme from './Theme.js';
import TlmPage from './TlmPage/TlmPage.jsx';
import SessionTimeout from './SessionTimeout/SessionTimeout.js';
import UpdateNotification from './UpdateNotification/UpdateNotification.js';
import { host } from "./data";
import MyTanksPage from './TlmPage/MyTanks/MyTanksPage.jsx';
import logoPulse from './Header/assets/Pulse_Level_Logo_black_v2.png';
import i18n from './i18n';
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';

const logo = logoPulse;

// Set AWS Cognito user pool credentials
Amplify.configure({
  Auth: {
    region: authConfig.region,
    userPoolId: authConfig.userPoolId,
    userPoolWebClientId: authConfig.userPoolWebClientId
  }
});

const useStyles = makeStyles((theme) => ({
  root: { height: '100vh', display: 'block' },
  content: { minHeight: 'calc(100vh - 64px)' },
  grow: { flexgrow: 1, },
}));

// Page router directs the app to the correct page and defines path parameters.
const PageRouter = ({ orgInfo, fetchOrgInformation, changeLanguage }) => {
  let data = useLocation();

  return (
    <Switch>
      {data.state
        ? <Route exact path='/orgs/new'> <OrgCreate firstOrg={orgInfo.orgId === "" ? true : false} orgInfo={data.state.orgInfo} orgEdit={data.state.orgEdit} fetchOrgInfo={fetchOrgInformation} changeLanguage={changeLanguage} /></Route>
        : <Route exact path='/orgs/new'> <OrgCreate firstOrg={orgInfo.orgId === "" ? true : false} orgInfo={orgInfo} orgEdit={false} fetchOrgInfo={fetchOrgInformation} changeLanguage={changeLanguage} /></Route>
      }
      <Route path='/orgs/:orgName/details'> <OrgDetails orgInfo={orgInfo} changeLanguage={changeLanguage} /></Route>
      <Route path='/orgs/:orgName/branches/:branchName'> <TlmPage orgInfo={orgInfo} changeLanguage={changeLanguage} /></Route>
      <Route path='/orgs'> <OrgPage orgInfo={orgInfo} fetchOrgInformation={fetchOrgInformation} changeLanguage={changeLanguage} /></Route>
      <Route path='/profile'> <ProfilePage fetchOrgInformation={fetchOrgInformation} changeLanguage={changeLanguage} /> </Route>
      <Route path='/help' component={HelpPage} changeLanguage={changeLanguage} />
      <Route path='/mytanks'> <MyTanksPage fetchOrgInformation={fetchOrgInformation} changeLanguage={changeLanguage} /> </Route>
      <Route path='/Demo Invite'> <DemoInvite fetchOrgInformation={fetchOrgInformation} changeLanguage={changeLanguage} /> </Route>
      <Route path='/'> <TlmPage orgInfo={orgInfo} changeLanguage={changeLanguage} /></Route>
    </Switch>
  );
}

// The main App. Loaded by index.js, the whole app trees from here.
export default function App() {
  const { t } = useTranslation();
  const history = useHistory();
  const params = useParams();
  const classes = useStyles();
  const cookies = new Cookies();
  const { set: setSessionstorageValue } = useSessionstorage("orgInfo", {});
  // Create state for the current org and org list.
  const [signedIn, setSignedIn] = React.useState(false);
  const [organization, setOrganization] = React.useState({
    orgName: '',
    isOrgEditor: true,
    orgId: ''
  });
  const [organizationsList, setOrganizationsList] = React.useState([]);
  const [organizationNavDict, setOrganizationNavDict] = React.useState({});
  const [orgsFetched, setOrgsfetched] = React.useState(false);
  const authTimeoutMinutes = 30; //auto sign out timeout
  const authWarningMinutes = 5; //Minutes remaining that popup occurs.

  const [showUpdateInfo, setShowUpdateInfo] = React.useState(false);

  const changeLanguage = (lng) => {
    console.log('Changing application language: ' + lng);
    i18n.changeLanguage(lng);
  }

  // Handle app events
  const handleAuthStateChange = (state) => {
    if (state === 'signedIn') { setSignedIn(true); }
    else { setSignedIn(false) };
  };

  // Handle organization change event. Passed to the nav menu in Header.
  const handleOrganizationChange = (event) => {
    setOrganization({
      orgName: event,
      isOrgEditor: organizationNavDict[event][1],
      orgId: organizationNavDict[event][0]
    });
    let url = '/';
    history.push(url);
  };

  // Get the org info. Runs once when the component mounts.
  function fetchOrgInformation(targetOrg, navigate, navUrl) {
    setOrgsfetched(false);

    Auth.currentAuthenticatedUser()
      .then(response => {
        try {
          response.getSession((err, session) => {
            if (err) {
              console.log(err);
              return;
            }

            console.log("Fetching orgs...")

            fetch(host + '/orgs?user=' + response.attributes.email, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': session.getIdToken().jwtToken
              }
            }).then(response => response.json())
              .then(data => {
                // If there is no default org, redirect user to the new org screen.
                if (data.default.orgName.trim() === "" && data.data.organizationList.length === 0) {
                  console.log("No orgs found.");
                  let url = '/orgs/';
                  history.push(url, { firstOrg: true });
                }
                else {
                  setOrganizationsList(data.data.organizationList);
                  setOrganizationNavDict(data.data.organizationNavDict);

                  if (targetOrg === "default") {
                    setOrganization({
                      orgName: data.default.orgName,
                      isOrgEditor: data.default.isOrgEditor,
                      orgId: data.default.orgId
                    });
                    let url = "/";
                    history.push(url);
                  }
                  else if (targetOrg !== undefined && data.data.organizationNavDict[targetOrg] !== undefined) {
                    setOrganization({
                      orgName: targetOrg,
                      isOrgEditor: data.data.organizationNavDict[targetOrg][1],
                      orgId: data.data.organizationNavDict[targetOrg][0]
                    });

                    if (navigate === true || navigate === undefined) {
                      let url = "/";
                      if (navUrl !== undefined) {
                        url = navUrl;
                      }
                      history.push(url);
                    }
                  }
                  else if (params.orgName !== undefined &&
                    params.orgName !== data.default.orgName &&
                    data.data.organizationNavDict[params.orgName] !== undefined) {
                    // Todo: Redirect to a "page does not exist or no access page" on an improper orgName in the url.
                    setOrganization({
                      orgName: params.orgName,
                      isOrgEditor: data.data.organizationNavDict[params.orgName][1],
                      orgId: data.data.organizationNavDict[params.orgName][0]
                    });
                  }
                  else {
                    if (data.default.orgId === "") {
                      var lOrgName = data.data.organizationList[0];
                      setOrganization({
                        orgName: lOrgName,
                        isOrgEditor: data.data.organizationNavDict[lOrgName][1],
                        orgId: data.data.organizationNavDict[lOrgName][0]
                      });
                    }
                    else {
                      setOrganization({
                        orgName: data.default.orgName,
                        isOrgEditor: data.default.isOrgEditor,
                        orgId: data.default.orgId
                      });
                    }
                  };
                }

                setOrgsfetched(true);
                console.log("Orgs fetched.")
              });
          });
        } catch (e) {
          console.log(e);
        }
      })
  };

  function fetchUserLanguageSetting() {
    Auth.currentAuthenticatedUser()
      .then(response => {
        try {
          response.getSession((err, session) => {
            if (err) {
              console.log(err);
              return;
            }

            console.log("Fetching user language setting...");

            fetch(host + '/user/settings', {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': session.getIdToken().jwtToken
              }
            }).then(response => response.json())
              .then(data => {
                if (data['lang'].lang !== undefined) {
                  changeLanguage(data['lang'].lang)
                  console.log("User language setting fetched.");
                  //console.log(data);
                } else {
                  console.log(cookies.get('login-lang'));
                  if (cookies.get('login-lang') !== undefined) {
                    changeLanguage(cookies.get('login-lang'));
                  }
                  clearShowUpdate(true);
                }
                if (data['lang'].show_update) {
                  setShowUpdateInfo(true);
                }
              });
          });
        } catch (e) {
          console.log(e);
        }
      })
  };

  function clearShowUpdate(show=false) {
    try {
    console.log("Clear Update Info Pop-up.");
    
    Auth.currentAuthenticatedUser()
      .then(response => {
        try {
          response.getSession((err, session) => {
            if (err) {
              console.log(err);
              return;
            }

            fetch(host + '/user/settings/clearshowupdate', {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': session.getIdToken().jwtToken
              },
              body: JSON.stringify({
                lang: cookies.get('login-lang') !== undefined ? cookies.get('login-lang') : 'en'
              })
            }).then(response => response.json())
              .then(data => {
                if (data['error'] !== "OK"){
                  console.log(data);
                }
                else{
                  setShowUpdateInfo(show);
                }
              });
          });
        } catch (e) {
          console.log(e);
        }
      })
    } catch (e) {
      console.log(e);
    }
  };

  React.useEffect(() => {
    if (signedIn) {
      fetchUserLanguageSetting();
      fetchOrgInformation();
    }
  }, [signedIn]);

  React.useEffect(() => {
    setSessionstorageValue(organization);
  }, [organization])

  //DISABLE MOUSE WHEEL FROM EFFECTING NUMBER TYPE
  document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
      document.activeElement.blur();
    }
  });

  // Setup the header and space for the page content through page router.
  return (
    <ThemeProvider theme={Theme}>
      <CssBaseline />
      {signedIn ?
        <>
          <Header orgInfo={organization} orgs={organizationsList} orgNavigationHandler={(event) => handleOrganizationChange(event)} changeLanguage={changeLanguage} />
          <div className={classes.content}>
            {orgsFetched ?
              <PageRouter orgInfo={organization} fetchOrgInformation={fetchOrgInformation} changeLanguage={changeLanguage} /> :
              <Typography align="center">{t("loadingOrgData")}...</Typography>
            }
            {orgsFetched && <UpdateNotification signedIn={signedIn} showUpdate={showUpdateInfo} onCloseFunction={clearShowUpdate}/>}
          </div>
        </>
        : <div className={classes.root + ' 1'}>
          <GAuth appTitle='Pulse Level'
            onAuthStateChange={handleAuthStateChange}
            logo={logo}
            changeLanguage={changeLanguage} />
        </div>
      }
      <div>
        <SessionTimeout signedIn={signedIn} maxTimeoutMinutes={authTimeoutMinutes} warningTimeoutMinutes={authWarningMinutes} />
      </div>
    </ThemeProvider>
  );
}